import Component from './wrapper';

export default Component;